var applyDelay = ms => new Promise(res => setTimeout(res, ms));
window.wineOrders = window.wineOrders || {};

// localStorage key

const lsKey     =   `__wineOrders__`;
const roughObj  =   {
  itemsCount: 0,
  items: [],
  upsellItems: [],
  shipping: 'Ship Now',
  shipDate: '',
  toggleState: 'no',
  note: '',
  cartNote: '',
  total: 0,
  link: '',
  ship_hot_weather: 'No'
}

wineOrders.getItems = (async function() {
  let rtn;
  await $.getJSON(`/cart.js`, function ( data ) {
    rtn = data;
  });
  return rtn;
})

$(document)
.ready(async function () {
  console.log( 'chaaa' );
  $( `body` )
    .removeClass( `overlay-shown` );
  manageOrders( `load` );
  // const items = await wineOrders.getItems();
})
.on(`click`, `.intro__link.intro__link-hide`, function( e ) {
  try {
    e.stopImmediatePropagation();
    e.preventDefault();
    $( this )
      .closest( `.wine__intro` )
      .slideUp();

  } catch ( err ) {
    console.log( `ERROR .intro__link.intro__link-hide`, err.message );
  }
})
// CART ITEMS PLUS / MINUS / REMOVE START
.on(`click`, `.itemContent__qtyWrap__plus`, function( e ) {
  try {
    e.stopImmediatePropagation();
    let qty   =   $( this ).closest( `.itemContent__qtyWrap` ).find( `.itemContent__qtyWrap__input` ).val() * 1;
    qty       =   qty + 1;
    console.log( `plus`, qty );    
    $( this ).closest( `.itemContent__qtyWrap` ).find( `.itemContent__qtyWrap__input` ).val( qty );
  } catch ( err ) {
    console.log( `ERROR .itemContent__qtyWrap__plus`, err.message );
  }
})
.on(`click`, `.itemContent__qtyWrap__minus`, function( e ) {
  try {
    e.stopImmediatePropagation();
    let qty   =   $( this ).closest( `.itemContent__qtyWrap` ).find( `.itemContent__qtyWrap__input` ).val() * 1;
    qty       =   qty - 1;
    if ( qty >= 0 ) {
      $( this ).closest( `.itemContent__qtyWrap` ).find( `.itemContent__qtyWrap__input` ).val( qty );
    }
  } catch ( err ) {
    console.log( `ERROR .itemContent__qtyWrap__minus`, err.message );
  }
})
.on(`click`, `.wine-cart .remove-item`, function( e ) {
  try {
    e.stopImmediatePropagation();
    const vid = $( this ).closest( `.wine-cart__item` ).attr( `vid` ) * 1;
    const isNormalProduct = $( `.wine-main__item[vid="${ vid }"] .itemContent__act .itemContent__qtyWrap__input` ).length;
    console.log ( 'isNormalProduct', isNormalProduct );
    if ( isNormalProduct > 0 ) {
      $( `.wine-main__item[vid="${ vid }"] .itemContent__act .itemContent__qtyWrap__input` ).val( 0 );
      $( `.wine-main__item[vid="${ vid }"] .itemContent__act .itemContent__btn` ).click();
    } else {
      console.log ( 'vid', vid );
      $( `.wine-cart__upsell__item[vid="${ vid }"]` ).attr( `cart`, 0 );
      addItems();
    }
  } catch ( err ) {
    console.log( `ERROR .wine-cart .remove-item`, err.message );
  }
})
// CART ITEMS PLUS / MINUS / REMOVE END

// ITEM MODAL EVENTS START
.on(`click`, `.wine-main__item--imgWrap`, function( e ) {
  try {
    e.stopImmediatePropagation();
    let getJSON   =   $( this ).closest( `.wine-main__item` ).find( `textarea` ).val();
    getJSON       =   JSON.parse( getJSON );

    if ( typeof getJSON !== 'undefined' && getJSON ) {
      modalOpen( getJSON );
      $( `.wine-modal` )
        .fadeIn();
    }

    console.log ( 'getJSON', getJSON );
  } catch ( err ) {
    console.log( `ERROR .wine-main__item--imgWrap`, err.message );
  }
})
.on(`click`, `.wine-modal__centerCenter__close`, function( e ) {
  try {
    e.stopImmediatePropagation();
    $( `.wine-modal__content` ).html( `` );
    $( `.wine-modal` )
      .fadeOut();
    $( `body` )
      .removeClass( `disabled` );
  } catch ( err ) {
    console.log( `ERROR .wine-main__item--imgWrap`, err.message );
  }
})
.on(`click`, `.wine-modal:not(.wine-modal__centerCenter)`, function( e ) {
  try {
    e.stopImmediatePropagation();
    $( `.wine-modal__centerCenter__close` ).click();
  } catch ( err ) {
    console.log( `ERROR `, err.message );
  }
})

// ITEM MODAL EVENTS END

// CART PANEL SHOW / HIDE START
.on(`click`, `.wine-header__cart`, function( e ) {
  try {
    e.stopImmediatePropagation();
    const getStatus = $( `.wine-cart` ).attr( `visibility` );

    if ( getStatus == false ) {
      $( `.wine-cart` )
        .attr( `visibility`, fasle )
        .closest( `body` )
        .removeClass( `overLay` );
    } else {
      $( `.wine-cart` )
        .attr( `visibility`, true )
        .closest( `body` )
        .addClass( `overLay` );

    cartPanelSetHeight();
    }
  } catch ( err ) {
    console.log( `ERROR .wine-header__cart`, err.message );
  }
})
.on(`click`, `.wine-cart__close`, function( e ) {
  try {
    e.stopImmediatePropagation();
    $( this )
      .closest( `.wine-cart` )
      .attr( `visibility`, false )
      .closest( `body` )
      .removeClass( `overLay` );
  } catch ( err ) {
    console.log( `ERROR .wine-cart__close`, err.message );
  }
})

.on(`blur`, `.wine-cart__cartNote-textarea`, function( e ) {
  try {
    e.stopImmediatePropagation();
    addItems();
  } catch ( err ) {
    console.log( `ERROR .wine-cart__cartNote-textarea`, err.message );
  }
})

// CART PANEL SHOW / HIDE START
.on(`click`, `.toggle`, function( e ) {
  try {
    e.stopImmediatePropagation();
    const getStatus = $( this ).attr( `status` );
    if ( getStatus == 'yes' ) {
      $( this ).attr( `status`, `no` );
      roughObj.toggleState = 'no'
    } else if ( getStatus == 'no' ) {
      $( this ).attr( `status`, `yes` );
      roughObj.toggleState = 'yes'
    }
    addItems();
  } catch ( err ) {
    console.log( `ERROR .toggle`, err.message );
  }
})
// ADD TO CART ITEMS START
.on(`click`, `.itemContent__act .itemContent__btn`, function( e ) {
  try {
    e.stopImmediatePropagation();
    addItems();
    $( `.wine-header__cart` ).click();
  } catch ( err ) {
    console.log( `ERROR .itemContent__act .itemContent__btn`, err.message );
  }
})
// ADD TO CART ITEMS END

.on(`change`, `#shipDate`, function( e ) {
  try {
    e.stopImmediatePropagation();
    addItems();
  } catch ( err ) {
    console.log( `ERROR #shipDate`, err.message );
  }
})
.on(`click`, `body.overLay .timesact_bis_popup_overlay`, function( e ) {
  try {
    e.stopImmediatePropagation();
    $( `.wine-cart__close` ).click();
  } catch ( err ) {
    console.log( `ERROR body.overLay .timesact_bis_popup_overlay`, err.message );
  }
})
.on(`click`, `.wine-cart__upsell__btn`, function( e ) {
  try {
    e.stopImmediatePropagation();
    let qty = $( this ).closest( `.wine-cart__upsell__item` ).attr( `cart` ) * 1;
    const limit = $( this ).closest( `.wine-cart__upsell__item` ).attr( `limit` ) * 1;
    if ( limit > qty ) {
      $( this ).closest( `.wine-cart__upsell__item` ).attr( `cart`, `${ qty + 1 }` );
      addItems();
    }
  } catch ( err ) {
    console.log( `ERROR .wine-cart__upsell__btn`, err.message );
  }
})

.on(`click`, `.shipToggle #shipYes`, function( e ) {
  try {
    e.stopImmediatePropagation();
    const isChecked = $( this ).is( `:checked` );
    if ( isChecked ) {
      $( `.toggle` ).attr( `status`, 'no' );
      addItems();
    }
  } catch ( err ) {
    console.log( `ERROR .shipToggle #shipYes`, err.message );
  }
})
.on(`click`, `.shipToggle #shipNo`, function( e ) {
  try {
    e.stopImmediatePropagation();
    const isChecked = $( this ).is( `:checked` );
    if ( isChecked ) {
      $( `.toggle` ).attr( `status`, 'yes' );
      addItems();
    }
  } catch ( err ) {
    console.log( `ERROR .shipToggle #shipNo`, err.message );
  }
})
.on(`click`, `.wine-cart__cartFooter__checkout`, function( e ) {
  try {
    e.stopImmediatePropagation();
    const getURL = $( this ).attr( `url` );
    if ( typeof getURL !== 'undefined' && getURL ) {
      window.history.pushState({}, '', '?setdata=yes');

      const cartObject    =   localStorage.getItem( lsKey );
      localStorage.setItem( `__checkoutClicked__`, cartObject );
      localStorage.removeItem( lsKey );
      location.href = getURL;
    }
  } catch ( err ) {
    console.log( `ERROR .wine-cart__cartFooter__checkout`, err.message );
  }
})

.on(`change`, `[name="hotWeatherOption"]`, function( e ) {
  try {
    e.stopImmediatePropagation();
    addItems();
  } catch ( err ) {
    console.log( `ERROR `, err.message );
  }
})

// REFRESH CART START
.on(`click`, `.wine-header__cartRefresh`, function( e ) {
  try {
    e.stopImmediatePropagation();
    localStorage.setItem( lsKey, '' );
    location.href = '?';

  } catch ( err ) {
    console.log( `ERROR .wine-header__cartRefresh`, err.message );
  }
})
// REFRESH CART END
;


function eligibleUpsell( itemsCount = 0 ) {
  try {
    $( `.wine-cart__upsell .wine-cart__upsell__item` ).each(function() {
      const alreadyInCart = $( this ).attr( `cart` ) * 1;
      const limit = $( this ).attr( `limit` ) * 1;
      if ( limit > alreadyInCart ) {
        $( this ).removeClass( `hide` );
      } else {
        $( this ).addClass( `hide` );
      }
    })
  } catch ( err ) {
    console.log( `ERROR eligibleUpsell()`, err.message );
  }
}


function manageOrders( type = '' ) {
  try {
    let mainObject  =   localStorage.getItem( lsKey );
    if ( typeof mainObject !== 'undefined' && mainObject ) {
      mainObject      =   JSON.parse( mainObject );

      console.log ( 'mainObject', mainObject );

      if ( type == 'load' ) {
        $( `.wine-header__cart [cart-count] span` ).text( mainObject.itemsCount );
        let collectItems = '';
        mainObject.items.forEach(el => {
          const vid = el.id;
          const qty = el.quantity;
          const img = el.img;
          const title = el.title;
          const price = el.price;

          collectItems +=   setHTML( vid, img, title, qty, price );
          $( `.wine-main__item[vid="${ vid }"] .itemContent__act .itemContent__qtyWrap__input` ).val( qty );
          if ( qty > 0 ) {
            $( `.wine-main__item[vid="${ vid }"] .itemContent__act .itemContent__btn` ).text( 'Update Cart' );
          }
        });

        mainObject.upsellItems.forEach(el => {
          const vid = el.id;
          const qty = el.quantity;
          const img = el.img;
          const title = el.title;
          const price = el.price;

          collectItems +=   setHTML( vid, img, title, qty, price );
          $( `.wine-cart__upsell__item[vid="${ vid }"]` ).attr( `cart`, qty );
        });
        $( `.wine-cart__items` )
          .html( collectItems );
        $( `.toggle` )
          .attr( `status`, mainObject.toggleState );
        if ( mainObject.toggleState == 'no' ) {
          $( `.shipToggle #shipYes` ).prop( 'checked', true );
          // $( `.shipToggle #shipYes` ).prop( 'checked', false );
        } else {
          $( `.shipToggle #shipNo` ).prop( 'checked', true );
        }
        if ( mainObject.shipDate != '' ) {
          console.log ( 'mainObject.date', mainObject.shipDate );
          $( `#shipDate` )
            .val( mainObject.shipDate );
        }
        if ( mainObject.ship_hot_weather == 'No' ) {
          $( `#hotWeatherNo` ).prop( 'checked', true );
        } else if ( mainObject.ship_hot_weather == 'Yes' ) {
          $( `#hotWeatherYes` ).prop( 'checked', true );
        } else {
          console.log ( 'chaaaaaaaa',  );
          $( `#hotWeatherNo` ).prop( 'checked', true );
        }
        if ( typeof mainObject.cartNote !== 'undefined' && mainObject.cartNote ) {
          $( `.wine-cart__cartNote-textarea` ).val( mainObject.cartNote );
        }
        addItems();
      }
    }
  } catch ( err ) {
    console.log( `ERROR manageOrders()`, err.message );
  }
}


function addItems() {
  try {
    const items = [];
    let count = 0;
    let itemsHTML = '';
    let total = 0;
    $( `.wine-main-products .wine-main__item` ).each(function() {
      const qty = $( this ).find( `.itemContent__qtyWrap__input` ).val() * 1;
      const vid = $( this ).attr( `vid` ) * 1;
      const title = $( this ).attr( `product-title` ).trim();
      const img = $( this ).attr( `product-img` ).trim();
      const price = $( this ).attr( `product-price` ).trim() * 1;

      if ( qty > 0 ) {
        const subTotal = price * qty;
        total = total + subTotal;
        $( this ).find( `.itemContent__btn` ).text( `Update Cart` );
        count = count + qty;
        items.push({
          id: vid,
          quantity: qty,
          title: title,
          img: img,
          price: price
        });
        itemsHTML  +=   setHTML( vid, img, title, qty, price );
      } else {
        $( this ).find( `.itemContent__btn` ).text( `Add to Cart` );
      }
    })
    $( `.wine-header__cart [cart-count] span` ).text( count );
    roughObj.items = items;
    roughObj.itemsCount = count;
    const getToggleState = $( `.wine-cart__cartImmediateShip__toggle` ).attr( `status` );
    roughObj.toggleState = getToggleState
    $( `.wine-cart__items` ).html( itemsHTML );
    const toggleStatus = $( `.toggle` ).attr( `status` );
    roughObj.toggleState = ( toggleStatus == 'no' ? 'no' : 'yes' );
    let note = 'Ship Now';
    const date = $( `#shipDate` ).val();
    if ( toggleStatus == 'yes' && date != '' ) {
      note = `Ship After ${ date }`;
    }
    if ( date != '' ) {
      roughObj.shipDate = date;
    }

    const cartNoteVal = $( `.wine-cart__cartNote-textarea` ).val();

    roughObj.note = `${ note }`;

    roughObj.cartNote = cartNoteVal;

    const upsellItems = [];
    $( `.wine-cart__upsell .wine-cart__upsell__item` ).each(function() {
      const cartItem = $( this ).attr( `cart` ) * 1;
      const img = $( this ).attr( `product-img` );
      const title = $( this ).attr( `product-title` );
      const price = $( this ).attr( `product-price` ).trim() * 1;
      const vid = $( this ).attr( `vid` ) * 1;
      if ( cartItem > 0 ) {
        const subTotal = price * cartItem;
        total = total + subTotal;
        $( `.wine-cart__items` )
          .append( setHTML( vid, img, title, cartItem, price ) );
        upsellItems.push({
          id: vid,
          img: `${ img }`,
          price: price,
          quantity: cartItem,
          title: `${ title }`
        });
      }
    })
    roughObj.upsellItems = upsellItems;
    roughObj.total = total;

    $( `.wine-cart__cartSubTotal__price` ).text( `$${ total }` );

    manageUpsell( count );

    const hotWeatherOption = $( `#hotWeatherNo` ).is( ':checked' );
    if ( hotWeatherOption ) {
      roughObj.ship_hot_weather = 'No';
    } else {
      roughObj.ship_hot_weather = 'Yes';
    }

    roughObj.note = `${ note }\nHold for hot weather: ${ roughObj.ship_hot_weather }\n-------\nCart Note: ${ cartNoteVal }`;

    const getLink = generateLink( roughObj );

    roughObj.link = getLink;

    localStorage.setItem( `${ lsKey }`, JSON.stringify( roughObj ) );
    eligibleUpsell();

    $( `.wine-cart__cartFooter__checkout` ).attr( `url`, getLink );

    if ( count == 0 ) {
      $( `.wine-cart__empty` ).show();
      $( `.wine-cart__base` )
        .hide();
    } else {
      $( `.wine-cart__empty` ).hide();
      $( `.wine-cart__base` )
        .removeAttr( `style` );
    }
  } catch ( err ) {
    console.log( `ERROR addItems`, err.message );
  }
}

async function cartPanelSetHeight() {
  try {
    await applyDelay( 300 );
    const cartHeight        =   $( `.wine-cart` ).outerHeight();
    const cartHeadHeight    =   $( `.wine-cart__head` ).outerHeight();
    // const cartMiddleHeight  =   $( `.wine-cart__middle` ).outerHeight();
    const cartFooterHeight  =   $( `.wine-cart__base` ).outerHeight();
    const middleHeight      =   cartHeight - cartHeadHeight - cartFooterHeight;
    if ( middleHeight > 120 ) {
      $( `.wine-cart__middle` ).css( `height`, `${ middleHeight - 10 }px` );
    }
  } catch ( err ) {
    console.log( `ERROR cartPanelSetHeight()`, err.message );
  }
}

function generateLink( o ) {
  try {
    let link = '/cart/';
    const groupArrays = o.items.concat( o.upsellItems );

    groupArrays.forEach((el, i) => {
      if ( i == 0 ) {
        link = `${ link }${ el.id }:${ el.quantity }`;
      } else {
        link = `${ link },${ el.id }:${ el.quantity }`;
      }
    });

    link  =  `${ link }?note=${ encodeURI( o.note ) }&attributes[page]=${ currentPage }`;
    return link;
  } catch ( err ) {
    console.log( `ERROR generateLink`, err.message );
  }
}


function manageUpsell( cartItemsCount ) {
  try {
    if ( cartItemsCount == 0 ) {
      $( `.wine-cart__upsell__item[item="1"]` )
        .attr( `limit`, 0 );
    } else if ( cartItemsCount <= 11 ) {
      $( `.wine-cart__upsell__item[item="1"]` )
        .attr( `limit`, 1 );
    } else if ( cartItemsCount <= 22 ) {
      $( `.wine-cart__upsell__item[item="1"]` )
        .attr( `limit`, 2 );
    } else if ( cartItemsCount <= 33 ) {
      $( `.wine-cart__upsell__item[item="1"]` )
        .attr( `limit`, 3 );
    } else if ( cartItemsCount <= 44 ) {
      $( `.wine-cart__upsell__item[item="1"]` )
        .attr( `limit`, 4 );
    }

    if ( cartItemsCount > 3 ) {
      $( `.wine-cart__upsell__item[item="2"]` )
        .attr( `limit`, 1 );
    } else {
      $( `.wine-cart__upsell__item[item="2"]` )
        .attr( `limit`, 0 );
    }
  } catch ( err ) {
    console.log( `ERROR `, err.message );
  }
}


function setHTML( vid, img, title, qty, price ) {
  try {
    let priceCalc = ``;
    if ( price == 0 ) {
      priceCalc = `Free`;
    } else {
      priceCalc = `$${ qty * price }`;
      // priceCalc = `$${ ( priceCalc ).toFixed(0) }`;
    }

    return `
      <div class="wine-cart__item" vid="${ vid }">
        <img src="${ img }" alt="${ title }" class="wine-cart__item__img">
        <div class="wine-cart__item__content">
          <div class="wine-cart__item__contentTitle">
            ${ title }
          </div>
          <div class="wine-cart__item__contentQty">
            ${ qty } x $${ price }
          </div>

          <div class="wine-cart__item__contentTotal">
            <pirce>
              ${ priceCalc }
            </pirce>
            <div class="remove-item ${ priceCalc == `Free` ? `upsell-item` : `` }">
              Remove
            </div>
          </div>
        </div>
      </div>
    `;
  } catch ( err ) {
    console.log( `ERROR `, err.message );
  }
}


function modalOpen( obj ) {
  try {
    $( `.wine-modal__content` )
      .html( `
        <modal-image>
          <img src="${ obj.img }" alt="${ obj.title }">
        </modal-image>
        <modal-content>
          <modal-title>${ obj.title }</modal-title>
          <modal-price>${ obj.price }</modal-price>
          <modal-description>${ obj.description }</modal-description>
        </modal-content>
      ` );
    $( `body` )
      .addClass( `disabled` );
  } catch ( err ) {
    console.log( `ERROR `, err.message );
  }
}

